/* eslint-disable no-nested-ternary */
import { Collapse, Divider } from "@material-ui/core";
import { Tooltip } from "@mui/material";
import moment from "moment";
import React from "react";

import { RootStateOrAny, useSelector } from "react-redux";
import formatarNumeroTelefone from "utils/regexPhone";
import { podeCorretorConcluirTarefa } from "utils/podeCorretorConcluirTarefa";
import { AuthState } from "../../../../store/ducks/auth/types";
import * as IconsSVG from "../../../../assets/iconsSVG";
import * as Styles from "./cardTarefas.styles";

interface Props {
  title: string;
  lead: string;
  statusTarefa: string;
  tipoTarefa: string;
  data: string;
  dataCriacaoTarefa?: string;
  dataConclusao: string;
  tipoConclusao: string;
  urlAnexo: string;
  obs: string;
  descricao: string;
  etapa: string;
  setEditTask: Function;
  editTask?: boolean;
  onItemEdit: Function;
  setConcludeTask: Function;
  concludeTask?: boolean;
  onItemConclude: Function;
  empreendimento: string;
  tipoResultadoTarefa: string;
  idLeadCorretor: string;
  telefonePrincipal: string;
  emailPrincipal?: string;
  hideActions?: boolean;
}

export function CardTarefas(props: Props) {
  const { codigoRegional365 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const isSul = codigoRegional365 === "2";
  const [expanded, setExpanded] = React.useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  return (
    <Styles.Container>
      <Styles.Header>
        <Tooltip title={props.title} followCursor arrow>
          <Styles.Title>{props.title}</Styles.Title>
        </Tooltip>
        <Styles.ButtonContainer>
          {props.statusTarefa === "Concluida" || props.hideActions ? (
            <></>
          ) : (
            <>
              <Tooltip title="Editar tarefa" placement="top" followCursor arrow>
                <Styles.ButtonEdit
                  onClick={() => {
                    props.setEditTask(!props.editTask);
                    props.onItemEdit();
                  }}
                >
                  <IconsSVG.PencilIcon
                    fillbox="0 -2 14 18"
                    size={18}
                    color="#2D5BFF"
                  />
                </Styles.ButtonEdit>
              </Tooltip>
              {podeCorretorConcluirTarefa(props.tipoTarefa, isSul) ? (
                <Tooltip
                  title="Concluir tarefa"
                  placement="top"
                  followCursor
                  arrow
                >
                  <Styles.ButtonConfirm
                    onClick={() => {
                      props.setConcludeTask(!props.concludeTask);
                      props.onItemConclude();
                    }}
                  >
                    <IconsSVG.DoneIcon />
                  </Styles.ButtonConfirm>
                </Tooltip>
              ) : null}
            </>
          )}

          <Styles.ButtonArrow
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            {expanded ? (
              <IconsSVG.ExpandIcon rotate={false} />
            ) : (
              <IconsSVG.ExpandIcon rotate />
            )}
          </Styles.ButtonArrow>
        </Styles.ButtonContainer>
      </Styles.Header>
      <Styles.Body href={`/lead-detail/${props.idLeadCorretor}`}>
        <IconsSVG.UserIcon />
        <Tooltip title="Visualizar Lead" followCursor arrow placement="top">
          <Styles.Subtitle style={{ marginLeft: 8, paddingBottom: 0 }}>
            {props.lead}
          </Styles.Subtitle>
        </Tooltip>
      </Styles.Body>
      {props.tipoTarefa !== "E-mail" && props.telefonePrincipal !== null ? (
        <Styles.Body
          href={`https://wa.me/${props.telefonePrincipal}`}
          target="_blank"
        >
          <IconsSVG.WhatsappIcon />
          <Tooltip
            title="Telefone principal"
            followCursor
            arrow
            placement="top"
          >
            <Styles.Subtitle style={{ marginLeft: 8, paddingBottom: 0 }}>
              {props.telefonePrincipal
                ? formatarNumeroTelefone(props.telefonePrincipal)
                : "--"}
            </Styles.Subtitle>
          </Tooltip>
        </Styles.Body>
      ) : (
        <>
          <Styles.Body href={`mailto:${props.emailPrincipal}`} target="_blank">
            <IconsSVG.MailOutlineIcon />
            <Tooltip
              title="E-mail principal"
              followCursor
              arrow
              placement="top"
            >
              <Styles.Subtitle style={{ marginLeft: 8, paddingBottom: 0 }}>
                {props.emailPrincipal}
              </Styles.Subtitle>
            </Tooltip>
          </Styles.Body>
        </>
      )}
      {props.statusTarefa !== "Concluida" &&
        (props.tipoTarefa === "Agendamento de Visita" ||
          props.tipoTarefa === "Mobi") && (
          <Styles.BodyInfo style={{ marginBottom: 16 }}>
            <Tooltip
              title={props.tipoTarefa}
              followCursor
              arrow
              placement="top"
            >
              <Styles.Subtitle>Tipo: {props.tipoTarefa}</Styles.Subtitle>
            </Tooltip>
            <Tooltip
              title={props.empreendimento}
              followCursor
              arrow
              placement="top"
            >
              <Styles.Subtitle>Produto: {props.empreendimento}</Styles.Subtitle>
            </Tooltip>
            <Tooltip title={props.data} followCursor arrow placement="top">
              <Styles.Subtitle>Data programada: {props.data}</Styles.Subtitle>
            </Tooltip>
          </Styles.BodyInfo>
        )}

      {props.statusTarefa === "Concluida" &&
        (props.tipoTarefa === "Agendamento de Visita" ||
          props.tipoTarefa === "Mobi") && (
          <Styles.BodyInfo style={{ marginBottom: 16 }}>
            <Tooltip
              title={props.tipoTarefa}
              followCursor
              arrow
              placement="top"
            >
              <Styles.Subtitle>Tipo: {props.tipoTarefa}</Styles.Subtitle>
            </Tooltip>
            <Tooltip
              title={props.empreendimento}
              followCursor
              arrow
              placement="top"
            >
              <Styles.Subtitle>Produto: {props.empreendimento}</Styles.Subtitle>
            </Tooltip>
            <Tooltip
              title={props.tipoResultadoTarefa}
              followCursor
              arrow
              placement="top"
            >
              <Styles.Subtitle>
                Resultado: {props.tipoResultadoTarefa}
              </Styles.Subtitle>
            </Tooltip>
            <Tooltip
              title={moment(props.dataConclusao).format("DD/MM/YYYY - HH:mm")}
              followCursor
              arrow
              placement="top"
            >
              <Styles.Subtitle>
                Conclusão:{" "}
                {moment(props.dataConclusao).format("DD/MM/YYYY - HH:mm")}
              </Styles.Subtitle>
            </Tooltip>
            <Tooltip title={props.obs} followCursor arrow placement="top">
              <Styles.Subtitle style={{ marginTop: 16 }}>
                Observação do resultado: {props.obs}
              </Styles.Subtitle>
            </Tooltip>
          </Styles.BodyInfo>
        )}

      {props.tipoTarefa !== "Agendamento de Visita" &&
        props.tipoTarefa !== "Mobi" &&
        props.statusTarefa !== "Concluida" && (
          <Styles.BodyInfo style={{ marginBottom: 16 }}>
            <Tooltip
              title={props.tipoTarefa}
              followCursor
              arrow
              placement="top"
            >
              <Styles.Subtitle>Tipo: {props.tipoTarefa}</Styles.Subtitle>
            </Tooltip>
            <Tooltip title={props.data} followCursor arrow placement="top">
              <Styles.Subtitle>Data programada: {props.data}</Styles.Subtitle>
            </Tooltip>
          </Styles.BodyInfo>
        )}

      {props.statusTarefa === "Concluida" &&
        props.tipoTarefa !== "Agendamento de Visita" &&
        props.tipoTarefa !== "Mobi" && (
          <Styles.BodyInfo style={{ marginBottom: 16 }}>
            <Tooltip
              title={props.tipoTarefa}
              followCursor
              arrow
              placement="top"
            >
              <Styles.Subtitle>Tipo: {props.tipoTarefa}</Styles.Subtitle>
            </Tooltip>
            <Tooltip
              title={props.tipoResultadoTarefa}
              followCursor
              arrow
              placement="top"
            >
              <Styles.Subtitle>
                Resultado: {props.tipoResultadoTarefa}
              </Styles.Subtitle>
            </Tooltip>
            <Tooltip
              title="Data de conclusão da tarefa"
              followCursor
              arrow
              placement="top"
            >
              <Styles.Subtitle>
                Conclusão:{" "}
                {moment(props.dataConclusao).format("DD/MM/YYYY - HH:mm")}
              </Styles.Subtitle>
            </Tooltip>
            <Tooltip title={props.obs} followCursor arrow placement="top">
              <Styles.Subtitle style={{ marginTop: 16 }}>
                Observação do resultado: {props.obs}
              </Styles.Subtitle>
            </Tooltip>
          </Styles.BodyInfo>
        )}
      <Styles.StatusTag
        style={{
          backgroundColor:
            props.statusTarefa === "Concluida"
              ? "#4CAF50"
              : props.statusTarefa === "Atrasada"
              ? "#F43636"
              : props.statusTarefa === "Em Aberto"
              ? "#D5D5D5"
              : "",
        }}
      >
        <Styles.TagText
          style={{
            color:
              props.statusTarefa === "Concluida"
                ? "#ffffff"
                : props.statusTarefa === "Atrasada"
                ? "#ffffff"
                : props.statusTarefa === "Em Aberto"
                ? "#333333"
                : "",
          }}
        >
          {props.statusTarefa}
        </Styles.TagText>
      </Styles.StatusTag>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Divider variant="middle" style={{ marginTop: 16, marginBottom: 16 }} />
        <Styles.TitleData>Dados da criação</Styles.TitleData>
        <Styles.Subtitle>Tipo: {props.tipoTarefa}</Styles.Subtitle>
        <Styles.Subtitle>Etapa: {props.etapa}</Styles.Subtitle>
        {props.empreendimento && (
          <Styles.Subtitle>Produto: {props.empreendimento}</Styles.Subtitle>
        )}
        <Styles.Subtitle>
          Criação da tarefa: {props?.dataCriacaoTarefa}
        </Styles.Subtitle>
        {props.descricao ? (
          <>
            <Styles.SubtitleObs>
              Descrição: {props.descricao}
            </Styles.SubtitleObs>
          </>
        ) : (
          <></>
        )}
        {props.statusTarefa === "Concluida" ? (
          <>
            {" "}
            <Divider
              variant="middle"
              style={{ marginTop: 16, marginBottom: 16 }}
            />
            <Styles.TitleData>Resultado da tarefa</Styles.TitleData>
            <Styles.Subtitle style={{ color: "#2D5BFF", marginBottom: 8 }}>
              {props.tipoConclusao}
            </Styles.Subtitle>
            <Styles.Subtitle style={{ marginBottom: 8 }}>
              Conclusão:{" "}
              {moment(props.dataConclusao).format("DD/MM/YYYY - HH:mm")}
            </Styles.Subtitle>
            <Styles.SubtitleObs style={{ marginTop: 16 }}>
              Observação do resultado: {props.obs}
            </Styles.SubtitleObs>
            {props.urlAnexo ? (
              <>
                <Styles.Title style={{ marginTop: 16 }}>Anexos</Styles.Title>
                <Styles.Subtitle style={{ color: "#2D5BFF", marginBottom: 8 }}>
                  <a href={props.urlAnexo}>Baixar arquivo</a>
                </Styles.Subtitle>
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
      </Collapse>
    </Styles.Container>
  );
}
